import React, { useState, useCallback, useEffect } from 'react';
import './index.css';
import Loader    from './components/Loader';
import Navbar    from './components/Navbar';
import Hero      from './components/Hero';
import Divisions from './components/Divisions';
import Products  from './components/Products';
import Order     from './components/Order';
import About     from './components/About';
import Future    from './components/Future';
import Contact   from './components/Contact';
import Footer    from './components/Footer';
import Chatbot   from './components/Chatbot';

export default function App() {
  const [ready, setReady] = useState(false);
  const handleDone = useCallback(() => setReady(true), []);

  useEffect(() => {
    if (!ready) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
    }, { threshold:0.1 });
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
    return () => io.disconnect();
  }, [ready]);

  return (
    <>
      <Loader onDone={handleDone} />
      {ready && (
        <>
          <Navbar />
          <main>
            <Hero />
            <Divisions />
            <Products />
            <Order />
            <About />
            <Future />
            <Contact />
          </main>
          <Footer />
          <Chatbot />
        </>
      )}
    </>
  );
}
